import { Center, Loader, LoaderProps } from "@mantine/core";

export interface CenteredLoaderProps {
  /**
   * Size of the loader
   */
  size?: LoaderProps["size"];
  /**
   * Minimum height of the container
   */
  minHeight?: string | number;
}

/**
 * A centered loader component that fills its container
 * Replaces the repeated pattern of Box with flex centering
 */
export function CenteredLoader({ size = "xl", minHeight = "100%" }: CenteredLoaderProps) {
  return (
    <Center mih={minHeight}>
      <Loader size={size} />
    </Center>
  );
}
